import request from "@/utils/request";

// 获取模块树数据
export const logout = () => {
  return request({
    url: `/logout`,
    method: "post",
  });
};
export const getInfo = () => {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}